export function attribution() {
  return "Le fond de plan est constitué à partir des données des contributeurs OSM et stylisé par Géo2France et Picardie Nature.";
}

export function credits() {
  // FIXME
  return "";
}
